import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const Pagehelmet = ({ pageTitle, description, image }) => {
  const location = useLocation(); // detects route changes
  const siteName = "Future Oil Conference 2026";
  const siteUrl = "https://futureoilconference.com";

  const defaultTitle = `${siteName} | AI, Data & Net-Zero Energy Shift`;
  const defaultDescription =
    "FutureOil 2026 (Feb 10-11, 2026, 100% Virtual on Hubilo) brings together global leaders in oil & gas, AI, big data, and sustainability to explore the future of energy transformation and net-zero strategies.";
  const defaultImage = `${siteUrl}/assets/images/og-default.jpg`;

  // Dynamic values
  const fullTitle = pageTitle ? `${pageTitle} | ${siteName}` : defaultTitle;
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;

  // Update document.title on every route change
  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle, location.pathname]);

  // JSON-LD Event Schema
  const eventSchema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "FutureOil 2026: AI, Data & Net-Zero Energy Shift Conference",
    startDate: "2026-02-10T09:00:00Z",
    endDate: "2026-02-11T18:00:00Z",
    location: {
      "@type": "VirtualLocation",
      url: siteUrl,
    },
    description: defaultDescription,
    offers: [
      {
        "@type": "Offer",
        url: `${siteUrl}/booknow`,
        name: "Super Early Pass",
        price: "199.00",
        priceCurrency: "USD",
        validFrom: "2025-09-01T00:00:00Z",
      },
      {
        "@type": "Offer",
        url: `${siteUrl}/booknow`,
        name: "Early Bird Pass",
        price: "299.00",
        priceCurrency: "USD",
        validFrom: "2025-11-01T00:00:00Z",
      },
      {
        "@type": "Offer",
        url: `${siteUrl}/booknow`,
        name: "Regular Pass",
        price: "399.00",
        priceCurrency: "USD",
        validFrom: "2026-01-01T00:00:00Z",
      },
    ],
    organizer: {
      "@type": "Organization",
      name: "ARO Events",
      url: "https://aroevents.com",
    },
  };

  return (
    <Helmet>
      {/* Title & Meta */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="author" content={siteName} />
      <meta
        name="keywords"
        content="FutureOil 2026, Oil and Gas Conference, Energy Conference 2026, Net Zero Energy, AI in Energy, Data in Oil and Gas, Digital Transformation, Sustainability, Hubilo Virtual Conference"
      />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={metaImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* JSON-LD Schema */}
      <script type="application/ld+json">{JSON.stringify(eventSchema)}</script>
    </Helmet>
  );
};

export default Pagehelmet;
